import { toast } from 'react-toastify';

import ToastBody from 'src/shared/components/ui/ToastBody';
import type { ToastAction } from 'src/shared/components/ui/ToastBody';

/**
 * Feedback that something happened, without taking over the screen.
 *
 * Success is confirmed here rather than with an alert inside a dialog that is
 * already closing. Errors that belong to a field stay next to the field; this
 * is for the ones with nowhere else to go (a row deleted from a list).
 */
export const notify = {
  success: (message: string, action?: ToastAction) =>
    toast.success(<ToastBody message={message} action={action} />),
  error: (message: string) => toast.error(<ToastBody message={message} />, { autoClose: 6000 }),
};
